import { RootState } from '@reducers';

export const selectOccupation = (state: RootState) => state.occupationReducer;
